module.exports = __webpack_public_path__ + "static/media/logo-itapolis.0fe7563e.png";